const types = {
  login: '[Auth] login',
  logout: '[Auth] logout',
  // UI
  uiSetError: '[UI] Set Error',
  uiRemoveError: '[UI] Remove Error',
  // Loading
  uiStartLoading: '[UI] Start Loading',
  uiFinishLoading: '[UI] Finish Loading',
  // Journal
  notesAddNew: '[Notes] Add New Note',
  notesActive: '[Notes] Set Active Note',
  notesLoad: '[Notes] Load Notes',
  notesUpdated: '[Notes] Updated Notes',
  notesUpdatedImage: '[Notes] Updated Image Note',
  notesDelete: '[Notes] Delete Note',
  notesLogoutCleanUp: '[Notes] Logout Clean Up'

};

export default types;
